import { OutOfBandMessageDTO, OutOfBandMessageSeverity } from 'core/api';
import { Message } from './modal';
import { Toaster } from './chakra-components';

export async function processOutOfBandMessages(outOfBandMessages: OutOfBandMessageDTO[]): Promise<void> {
	for (const msg of outOfBandMessages) {
		if (msg.IsBlocking) {
			await Message.show(msg.Message);
		}
		else {
			switch (msg.Severity) {
				case OutOfBandMessageSeverity.Info: Toaster.info(msg.Message); break;
				case OutOfBandMessageSeverity.Warning: Toaster.warn(msg.Message); break;
				case OutOfBandMessageSeverity.Error: Toaster.error(msg.Message); break;
			}
		}
	}
}